<template>
    <div v-if="visible" class="modal-overlay" style="display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 1000;">
        <div class="modal-content" style="display: flex; flex-direction: column; width: 623px; padding-bottom: 26px; background: white; border-radius: 8px;">
            <!-- Modal Header -->
            <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
                <h3>¿Estás seguro de que deseas enviar el correo?</h3>
                <button type="button" class="btn-close" @click="closeModal" style="background: none; border: none; font-size: 20px;">×</button>
            </div>
            <!-- Modal Body -->
            <div class="modal-header" style="padding: 16px; display: flex; align-items: center; gap: 4px; justify-content: flex-start;">
                <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 24 24" fill="none" style="margin-right: 2px; flex-shrink: 0;">
                    <rect x="3" y="5" width="18" height="14" rx="2" stroke="#FF4265" stroke-width="1.5"/>
                    <path d="M3.5 6.5l8.5 6 8.5-6" stroke="#FF4265" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p style="margin:0; text-align: left; word-break: break-word;">
                    Se enviará la notificación a: <strong>{{ destinatarios }}</strong>
                </p>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px 16px;">
                <button @click="closeModal" style="padding: 10px 16px; border-radius: 4px; background: var(--Neutral-Ne-Medium-Weak, #737373); color: #fff; border: none;">
                    Cancelar
                </button>
                <button @click="confirmSend" style="padding: 10px 16px; border-radius: 4px; background: var(--Primary-Primary, #FF4265); color: #fff; border: none;">
                    Confirmar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      destinatarios: {
        type: String,
        default: '',
      },
    },
    emits: ['close', 'confirm'],
    methods: {
      closeModal() {
        this.$emit('close');
      },
      confirmSend() {
        this.$emit('confirm');
      },
    },
  };
</script>
